// DE: Startwerte bis 2^31, damit der Zufallsgenerator sie verlustfrei übernimmt.
// EN: Seeds up to 2^31 so the random generator takes them without loss.
const SEED_LIMIT = 2 ** 31;

/**
 * DE: Zufälliger Startwert: jeder neue Plan sieht anders aus, bleibt aber nachrechenbar.
 * EN: Random seed: every new plan looks different but can be recalculated.
 */
export function randomSeed(): number {
  return Math.floor(Math.random() * SEED_LIMIT);
}
